import Alpine from "alpinejs";
import { filestackPicker } from "../uploader";
import { fetchJSON } from "../api";

Alpine.data("simpleFileInput", ({ s3PathPrefix, accept, maxKilobyteSize, callbackUrl, moduleId }) => ({
  async pickFile() {
    const { filesUploaded } = await filestackPicker({
      path: s3PathPrefix,
      accept: accept,
      maxFiles: 1,
      maxSingleFileSize: maxKilobyteSize ? 1024 * maxKilobyteSize : null,
    });

    if (filesUploaded?.length) {
      const files = filesUploaded.map((file) => ({
        url: file.url,
        filename: file.filename,
        mime: file.mimetype,
        size: file.size,
      }));

      const body = {
        files: JSON.stringify(files),
      };

      const response = await fetchJSON(callbackUrl, { method: "POST", body });
      if (!response.success) {
        throw response.error;
      }

      const url = new URL(location.href);
      url.searchParams.set("module_id", moduleId);
      location.href = url.toString();
    }
  },
}));
